"use client";

import { useState } from "react";
import { X } from "lucide-react";
import { Dialog, DialogContent, DialogOverlay, DialogPortal } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517610/img/email_campaign_mockup.png",
  alt: "Email campaign mockup showing targeted restaurant promotion",
  tall: true
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517610/img/analytics_dashboard_overview.png",
  alt: "Analytics dashboard displaying campaign performance metrics",
  tall: false
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517610/img/subscriber_growth_chart.png",
  alt: "Subscriber growth chart showing exponential list building results",
  tall: false
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517610/img/reservation_integration_interface.png",
  alt: "Reservation system integration interface with POS connection",
  tall: true
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517610/img/mobile_email_preview.png",
  alt: "Mobile-optimized email preview for restaurant diners",
  tall: false
}, {
  id: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517610/img/conversion_rate_report.png",
  alt: "Conversion rate report highlighting repeat visit metrics",
  tall: true
}];
export default function ResultsGallery() {
  const [selectedImage, setSelectedImage] = useState<typeof galleryImages[0] | null>(null);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section ref={ref} className="py-24 px-4 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-4">
            Results Gallery
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Visual proof of our email marketing success stories for restaurant clients
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 auto-rows-auto">
          {galleryImages.map((image, i) => <div key={image.id} data-index={i} className={`
                group relative overflow-hidden rounded-lg shadow-soft cursor-pointer
                ${image.tall ? "row-span-2" : "row-span-1"}
                ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
                transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)]
              `} style={{
          transitionDelay: `${i * 150}ms`
        }} onClick={() => setSelectedImage(image)}>
              <div className="relative w-full h-full min-h-[300px] group-hover:scale-102 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
                <img src={image.src} alt={image.alt} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-[var(--duration-medium)]" />
              </div>
            </div>)}
        </div>
      </div>

      <Dialog open={!!selectedImage} onOpenChange={open => !open && setSelectedImage(null)}>
        <DialogPortal>
          <DialogOverlay className="bg-black/80 backdrop-blur-sm" />
          <DialogContent showCloseButton={false} className="max-w-[95vw] max-h-[95vh] w-auto h-auto p-0 border-0 bg-transparent shadow-none" onEscapeKeyDown={() => setSelectedImage(null)}>
            <div className="relative">
              <button onClick={() => setSelectedImage(null)} className="absolute -top-12 right-0 p-2 text-white hover:text-white/80 transition-colors z-10" aria-label="Close">
                <X className="size-8" />
              </button>
              {selectedImage && <img src={selectedImage.src} alt={selectedImage.alt} className="max-w-full max-h-[90vh] object-contain rounded-lg" onClick={e => e.stopPropagation()} />}
            </div>
          </DialogContent>
        </DialogPortal>
      </Dialog>
    </section>;
}